define('views/blocks/checkout/BaguettesReutilisablesDialogView',['views/blocks/checkout/CheckoutDialogView','app','template!blocks/checkout/dialog-baguettes-reutilisables'],
    function (CheckoutDialogView,app,dialogBaguetteReutilisablesTemplate) {

        return CheckoutDialogView.extend({
            getInner:function(){
                var baguettesReutilisable = app.getProduct(app.c('_BAGUETTES_REUTILISABLES_'));
                var message = app.t("Sushi Shop s'engage à réduire les déchets. Les baguettes jetables ne sont plus proposées. Vous pouvez sélectionner nos baguettes réutilisables à %s","Checkout",baguettesReutilisable.formatPrice('ttc', true, app.getCart()))
                return dialogBaguetteReutilisablesTemplate({
                    title:app.t('Nouveauté','UI'),
                    message:message,
                    imgUrl:baguettesReutilisable.getPictureUrl(),
                });
            },
            getSubmitText:function(){
                return app.t("J'ai compris",'UI');
            },
            submit:function(){
                this.close();
                localStorage.BAGUETTES_REUTILISABLES_WARN_DATE = (new Date()).toISOString();
                return false;
            }
        });
    });
